import { Component, ComponentFactory, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { HomeComponent } from '../main/home/home.component';
import * as moment from "moment";
import { MainService } from '../main/main.service';
@Component({
  selector: 'app-scholarships',
  templateUrl: './scholarships.component.html',
  styleUrls: ['./scholarships.component.css']
})
export class ScholarshipsComponent implements OnInit {
  @ViewChild("alertContainer", { read: ViewContainerRef }) container;
  componentRef: any;
  currentTime = "";
  isLoading:boolean = false;
  constructor(private resolver: ComponentFactoryResolver,private mainservice:MainService) { }

  ngOnInit(): void {
    this.currentTime =  this.greeting()
    this.getScholarShipsList()
  }

  createComponent() {
    this.container.clear(); 
    const factory = this.resolver.resolveComponentFactory(HomeComponent);
    this.componentRef = this.container.createComponent(factory);
  }

   greeting() {
     const hour = moment().hour();
 
     if (hour > 16){
         return "Good evening";
     }
 
      if (hour > 11){
          return "Good afternoon";
      }
 
      return 'Good morning';
 }
 
 scholarshipsList = [];
 getScholarShipsList(){
   this.isLoading = true;
   let query = "";
   this.mainservice.getScholarShipHomeApi(query).subscribe((res) => {
     this.isLoading = false;
      if(res['message'] =='Success') {
       this.scholarshipsList = res.data.response;
      } 
    }, err => {
      this.isLoading = false;
    });
 }

}
